import {SessionData} from '@/api/User/useGetPlayerSession';
import {MobileBaselineSessionTable} from '@/components/Baseline/SessionTable/MobileBaselineSessionTable';
import moment from 'moment';

export const ConnectsBaselineSessionData = ({
  startTime,
  baselineLevel,
  totalBallsFired,
  repetitions,
  exercises,
  isV3Session,
  sessionName,
  score,
}: {
  startTime: number;
  baselineLevel: string;
  totalBallsFired: number;
  repetitions: number;
  exercises: SessionData['exercises'];
  isV3Session: boolean;
  sessionName: string;
  score: number;
}) => {
  const startDate = startTime ? moment(startTime).format('MMM DD, YYYY') : '';
  let sessionDisplayText = `${baselineLevel} Baseline - ${startDate}`;
  if (isV3Session) {
    // Determine if this is a retest session based on sessionName format
    // First check if session name follows "num-num" pattern, then check if it doesn't include '-0'
    const hasNumNumPattern = sessionName && /^\d+-\d+/.test(sessionName);
    const isRetestSession = hasNumNumPattern && !sessionName.includes('-0');
    sessionDisplayText = isRetestSession
      ? `Level ${baselineLevel} Baseline Retest - ${startDate}`
      : `Level ${baselineLevel} Baseline - ${startDate}`;
  }
  return (
    <>
      <div className="flex flex-col lg:rounded lg:shadow-dispersed lg:overflow-hidden">
        <div className="text-lg text-white font-medium uppercase">
          <p className="p-3 text-center bg-secondary">{sessionDisplayText}</p>
          <div className="p-3 bg-primary flex items-center justify-around">
            <div className="flex gap-2 items-center justify-center">
              <p>Balls:</p>
              <div className="h-[40px] w-[40px] rounded-full grid place-content-center bg-secondary">
                <p>{totalBallsFired}</p>
              </div>
            </div>
            <div className="flex gap-2 items-center justify-center">
              <p>Sets:</p>
              <div className="h-[40px] w-[40px] rounded-full grid place-content-center bg-secondary">
                <p>{exercises.length}</p>
              </div>
            </div>
            {isV3Session && score > 0 && (
              <div className="flex gap-2 items-center justify-center">
                <p>Score:</p>
                <div className="h-[40px] w-[40px] rounded-full grid place-content-center bg-secondary">
                  <p>{score}</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <MobileBaselineSessionTable exercises={exercises} baselineLevel={baselineLevel} isV3Session={isV3Session} />
      </div>
    </>
  );
};
